import { DashboardLayout } from '@/components/dashboard-layout';
import { CommunitySettingsTabs } from '@/components/settings/community-settings-tabs';
import { SettingsTabs } from '@/components/settings/settings-tabs';
import { IS_SELF_HOSTED_CE } from '@/config';
import { ROUTES } from '@/utils/routes';

export function SettingsPage() {
  return (
    <DashboardLayout headerStartItems={<h1 className="text-foreground-950">Settings</h1>}>
      {IS_SELF_HOSTED_CE ? (
        <CommunitySettingsTabs />
      ) : (
        <SettingsTabs
          rootRoute={ROUTES.SETTINGS}
          routes={{
            account: ROUTES.SETTINGS_ACCOUNT,
            organization: ROUTES.SETTINGS_ORGANIZATION,
            team: ROUTES.SETTINGS_TEAM,
            billing: ROUTES.SETTINGS_BILLING,
          }}
        />
      )}
    </DashboardLayout>
  );
}
